import { header } from './modules/header';
import { animation } from './modules/animation';
import { accordion } from './modules/accordion';
header();
animation();
accordion();
